import React, { Component } from 'react';

class ThankYou extends Component {
    constructor(props) {
        super(props);
    }
    state = {  }
    render() { 
        return (
            <div className="container">
                <h1>Vielen Dank</h1>
                <p>Wir haben Ihre Anmeldung erhalten. Wir melden uns bei Ihnen mit weiteren Anweisungen.</p>
            </div>
        );
    }
}
 
export default ThankYou;